export default __webpack_public_path__ + "static/media/bg-afternoon.6dfaf282.jpg";